<template>
      <div class="card-container tw-h-full">
        <div class="card-title">{{ title }}</div>
        <div class="card-body">
          <slot name="body" />
        </div>
      </div>
    </template>

<script>
import { Component, Vue } from 'vue-property-decorator'

    @Component({
      name: 'InfoBoxPanel',
      props: {
        title: {
          type: String,
          default: ''
        }
      }
    })
class InfoBoxPanel extends Vue {
      get title () {
        return this.$props.title
      }
    }

export default InfoBoxPanel
</script>

    <style lang="scss" scoped>
    @import "tailwindcss/utilities";

    .card-container {
      position: relative;
      border: 1px solid #e5e5e5;
      border-radius: 0.25rem;
      margin-top: 1rem;
      padding: 1rem;
    }

    .card-title {
      position: absolute;
      top: -0.75rem;
      left: 1rem;
      background-color: white;
      padding: 0 0.5rem;
      color: #1c619f;
    }

    .card-body {
      padding: 0.75rem 0;
    }
    </style>
